import axios from 'axios'

const state = {
    staffUsers: [],
    staffUser: [],
    staffIsAdded: false, //Индикатор добавления нового пользователя для обновления списка
    staffUserview: {} //Полная информация о юзере (данные профиля, рольб статус)
};

const getters = {
    staffUsers: state => {
        return state.staffUsers
    },
    staffUser: state => {
        return state.staffUser
    },
    staffIsAdded: state => {
        return state.staffIsAdded
    },
    staffUserview: state => {
        return state.staffUserview
    }
};

const mutations = {
    staffUsers: (state, payload) => {
        return state.staffUsers = payload
    },
    staffUser: (state, payload) => {
        return state.staffUser = payload
    },
    staffIsAdded: (state, payload) => {
        return state.staffIsAdded = !state.staffIsAdded
    },
    staffUserview: (state, payload) => {
        return state.staffUserview = payload
    }
};

const actions = {
//GET
    staffUsersGet({commit}, role) {
        return axios({
                    method: 'GET',
                    url: 'profiles-with-user',
                    params: {
                        pg: 0,
                        batch: 20,
                        role: role ? role : null,
                        status: 1
                    }
                })
                .then(response => {
                    commit('staffUsers', response.data.data)
                })
                .catch(err => {
                    console.error('Ошибка скачивания списка сотрудников: ', err)
                })
    },
    staffUserGet({commit}, id) {
        return axios({
                    method: 'GET',
                    url: 'profiles/' + id
                })
                .then(response => {
                    commit('staffUser', response.data.data)
                })
                .catch(err => {
                    console.error('Ошибка получения сотрудника: ', err)
                })
    },
    staffIsAdded({commit}) {
        commit('staffIsAdded')
    },
    staffUserviewGet({commit}, uid) {
        return axios({
            method: 'GET',
            url: 'userview/' + uid 
        })
        .then(response => {
            commit('staffUserview', response.data.data)
        })
        .catch(err => {
            console.error('Ошибка получения сотрудника userview: ', err)
        })
    },
    staffChangeUserStatus(context, { id, roles, status }) {
        return axios({
            method: 'PATCH',
            url: 'user/' + id,
            data: {
                uid: id,
                roles: roles,
                status: status
            }
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}